import { z } from "zod";

export const insuranceFormSchema = z.object({});
export type InsuranceFormValues = z.infer<typeof insuranceFormSchema>;
